module.exports = __webpack_public_path__ + "static/media/icon_40.5a81c949.svg";